/**
 * Features the player dreamed up herself — she sat down, typed her own ideas into the
 * game, and became a game developer on her very own gift. 💛
 *
 * Append a line here every time she adds her own flair. (Shown in Settings → Credits,
 * and gently acknowledged in-world the first time you experience each one.)
 */
export interface Contribution {
  /** A short, warm name for the feature. */
  feature: string;
  /** One line on what it does / what she imagined. */
  note: string;
  /** Optional one-time in-world acknowledgement flag (localStorage key suffix). */
  flag?: string;
}

export const PLAYER_IDEAS: Contribution[] = [
  { feature: 'The wandering cat 🐈', note: 'strolls off to do its own thing, naps, chases birds, and visits Clara', flag: 'catwander' },
  { feature: 'The house that grows 🏰', note: 'renovate your little home all the way up to a castle', flag: 'housegrows' },
];
